<app-mini-layout-wrapper [showLogout]="!isRunning">
  <div class="mini-layout__title">{{text.title}}</div>
  <div class="mini-layout__btn">
      <app-ui-button class="g-margin-top-30" [variant]="'primary'" [size]="'small'" [label]="text.buttonText"
                     [isLoadingState]="isRunning" [capability]="capability" (clicked)="enable()">
      </app-ui-button>
  </div>
</app-mini-layout-wrapper>
